// Shown in place of the plan card (result and account screens) when the surgery was recent
// and we have no protocol for it: the API's post-op guard holds the standard plan back and a
// person sets one up. Honest about why there is no plan yet and who sets it up; it never
// claims a plan is ready. No dashes in this copy (patient-facing).
import { providerNoun } from '../lib/noun';

export function HeldNotice({ country }: { country: string }) {
  return (
    <div>
      <div style={{ fontSize: 18, fontWeight: 800 }}>After a recent surgery</div>
      <div style={{ fontSize: 14, fontWeight: 600, color: 'var(--slate)', marginTop: 8, lineHeight: 1.55 }}>
        Because your surgery was recent, we will not start you on a standard exercise plan. A person from our team will help set up a plan that fits your surgery and where you are in your recovery.
      </div>
      <div style={{ fontSize: 14, fontWeight: 700, color: 'var(--teal-deep)', marginTop: 12, lineHeight: 1.55 }}>
        Until then, follow the instructions from your surgeon or {providerNoun(country)}.
      </div>
    </div>
  );
}
